/**
 * Coda - SPECIFICHE 9.1
 *
 * Sistema di tracciamento code di presentazione deleghe.
 */
import { z } from 'zod';
import { CassaCodeSchema, str } from './common.ts';

export const CodaSchema = z.object({
  id: z.number(),
  cassa: CassaCodeSchema,
  dataPresentazione: z.string(), // YYYY-MM-DD
  createdAt: str,
});

export type Coda = z.infer<typeof CodaSchema>;

export type CodaInsert = Omit<Coda, 'id' | 'createdAt'>;

// Esito di una delega nella presentazione, calcolato dal primo import successivo
export const EsitoPresentazioneSchema = z.enum(['CONFERMATA', 'SCARTATA', 'IN_ATTESA']);

export type EsitoPresentazione = z.infer<typeof EsitoPresentazioneSchema>;

export const ETICHETTA_ESITO_PRESENTAZIONE: Record<EsitoPresentazione, string> = {
  CONFERMATA: 'Confermata', SCARTATA: 'Scartata', IN_ATTESA: 'In attesa di esito',
};

export const etichettaEsito = (v: string): string =>
  ETICHETTA_ESITO_PRESENTAZIONE[v as EsitoPresentazione] ?? v;

// CodaConCount: definita in types/api-responses.ts come schema Zod

// Associazione coda <-> delega
export const CodaDelegaSchema = z.object({
  codaId: z.number(),
  delegaId: z.number(),
});

export type CodaDelega = z.infer<typeof CodaDelegaSchema>;
